<template>
  <div>
    <Activities />
  </div>
</template>

<script>
import Activities from '@/components/Activities.vue'

export default {
  name: 'ActivitiesView',
  components: {
    Activities
  }
}
</script>
